// CSS Modules - component class name prefix: StartPage__

<template>
  <div :class="$style.container">
    <PageHeader />
    <HeroSlider :slides="slides" />
    <ProductArea :productLinks="productLinks" />
    <div :class="[$style.contentGrid, 'columns']">
      <div class="column">
        <ContentTeaserS
          :isVideo="false"
          primaryLink="#"
          :primaryLinkNewWindow="true"
          secondaryLink="#"
          :secondaryLinkNewWindow="false"
          category="Blog"
          linkTitle="Thermometer kalibrieren – ein Überblick"
          image="https://blog.wika.de/files/2019/05/thermometer_kalibrieren-300x169.jpg"
          :wtParams="{
            description: 'Englischer titel',
            doctype: 'blog'
          }"
        />
      </div>
      <div class="column">
        <ContentTeaserS
          :isVideo="true"
          primaryLink="https://www.youtube.com/embed/QbPEuTQvaiw?enablejsapi=1"
          :primaryLinkNewWindow="false"
          secondaryLink="#"
          :secondaryLinkNewWindow="false"
          category="Video"
          linkTitle="Industrielle Kraftsensoren | Welche Sensortechnologien zur Kraftmessung gibt..."
          image="https://de-de.wika.de/upload/WIKA_Thumbnails/Info-Box-Single-Thumb/PIC_NE_CPH7000Ex_de_de_99747.jpg.png"
          :wtParams="{
            description: 'Englischer titel',
            doctype: 'video'
          }"
        />
      </div>
      <div class="column">
        <SalesContainer :config="salesContainerConfig" />
      </div>
    </div>
    <div :class="[$style.eventGrid, 'columns']">
      <div v-for="(event, index) in events" class="column" :key="index">
        <EventTeaser :data="event" />
      </div>
    </div>
    <div :class="[$style.contentGrid, 'columns']">
      <div class="column is-two-thirds">
        <ContentTeaserM
          :isVideo="false"
          primaryLink="#"
          :primaryLinkNewWindow="true"
          secondaryLink="#"
          :secondaryLinkNewWindow="false"
          category="Neuheiten"
          linkTitle="Portabler Prozesskalibrator"
          image="https://www-prod.wika.com/media/10__images/news_1/pr0920_en_co_rs_w738_h410_image.jpg"
          text="Der portable Prozesskalibrator CPH7000 von WIKA hat die ATEX-Zulassung erhalten."
          :wtParams="{
            description: 'Englischer titel',
            doctype: 'news'
          }"
        />
      </div>
      <div class="column is-one-third">
        <SingleImageText
          image="https://www-prod.wika.com/media/10__images/contentteaser/company/developmentcenter_de_de_rs_w738_h410_image.jpg"
          title="Kraftsensoren"
          copy="Wir bedanken uns bei allen Teams und Teilnehmern am WIKA-Staffelmarathon."
          link="#"
        />
      </div>
    </div>
    <Footer />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
    <GeoIPOverlay :config="geoIpConfig" />
  </div>
</template>

<script>
import ContentTeaserM from "../ContentTeaserM/ContentTeaserM.vue";
import ContentTeaserS from "../ContentTeaserS/ContentTeaserS.vue";
import Footer from "../Footer/Footer.vue";
import HeroSlider from "../HeroSlider/HeroSlider.vue";
import PageHeader from "../PageHeader/PageHeader.vue";
import ProductArea from "../ProductArea/ProductArea.vue";
import EventTeaser from "../EventTeaser/EventTeaser.vue";
import SalesContainer from "../SalesContainer/SalesContainer.vue";
import SingleImageText from "../SingleImageText/SingleImageText.vue";
import ContactForm from "../ContactForm/ContactForm.vue";
import FeedbackForm from "../FeedbackForm/FeedbackForm.vue";
import OrderForm from "../OrderForm/OrderForm.vue";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer.vue";
import GeoIPOverlay from "../GeoIPOverlay/GeoIPOverlay.vue";

import Slide1 from "../../assets/hero/PIC_HE_Welcome_fw_de_de_93008.jpg";
import Slide2 from "../../assets/hero/PIC_HE_Shop_fw_de_de_92822.jpg";
import Slide3 from "../../assets/hero/PIC_HE_Resilience_fw_de_de_92812.jpg";
import Slide4 from "../../assets/hero/PIC_HE_Efficiency_fw_de_de_92813_92813.jpg";
import Slide5 from "../../assets/hero/PIC_HE_Reliability_fw_de_de_92802.jpg";

import FlagDeSmall from "../../assets/de_small.png";

export default {
  name: "StartPage",
  components: {
    ContentTeaserM,
    ContentTeaserS,
    EventTeaser,
    Footer,
    HeroSlider,
    PageHeader,
    ProductArea,
    SalesContainer,
    SingleImageText,
    ContactForm,
    FeedbackForm,
    OrderForm,
    CookieDisclaimer,
    GeoIPOverlay
  },
  data() {
    return {
      geoIpConfig: {
        websiteCountry: "EN",
        title: "Are you right here?",
        text: "We offer a local website for {{countryName}}.",
        countriesJSON:
          "http://www-qa.wika.dev.intern.etecture.de/json/country_UK.json",
        changeButtonText: "Change now",
        stayButtonText: "Stay here"
      },
      salesContainerConfig: {
        title: "Default Title",
        text:
          "Default Fragen? Finden Sie Ihren Ansprechpartner im WIKA-Vertriebsteam.",
        icon: "fas fa-user-tie",
        input: {
          placeholderText: "Postleitzahl eingeben",
          submitUrl: "contact_de_at.WIKA?cnType=1&cnEntry="
        },
        buttons: [
          {
            icon: "fas fa-comments",
            offlineText: "Unser Chat befindet sich in der Wartung.",
            text: "cHAT"
          },
          {
            icon: "fas fa-envelope",
            text: "Kontaktformular",
            linkUrl: "#"
          }
        ]
      },
      slides: [
        {
          captionTop: false,
          captionLeft: false,
          imageWidth: 1024,
          imageHeight: 344,
          image: Slide1,
          newWindow: false,
          text:
            "WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. Auf Basis unserer hochwertigen Messtechnik-Komponenten entwickeln wir gemeinsam mit unseren Kunden umfassende Lösungen, die wir in ihre Geschäftsprozesse integrieren.",
          title: "Willkommen bei WIKA SF<sup>6</sup>",
          url: "#"
        },
        {
          captionTop: true,
          captionLeft: true,
          image: Slide2,
          imageWidth: 1024,
          imageHeight: 344,
          newWindow: false,
          text:
            "Auswählen, bestellen, erhalten – made by WIKA. In unserem WIKA Online-Shop stehen Ihnen unsere Produkte in gewohnter WIKA-Qualität zur Verfügung. Wählen Sie schnell und einfach Ihr passendes Produkt aus unserem Standardportfolio.",
          title: "WIKA Online-Shop",
          url: "#"
        },
        {
          captionTop: false,
          captionLeft: true,
          image: Slide3,
          imageWidth: 1024,
          imageHeight: 344,
          newWindow: false,
          text:
            "Qualität ist das entscheidende Element des Erfolgs jedes Unternehmens. Wir wissen, worauf es in den Betriebsabläufen unserer Kunden ankommt. Deswegen machen wir bei der Qualität keine Kompromisse.",
          title: "Belastbarkeit liegt im Detail",
          url: "#"
        },
        {
          captionTop: true,
          captionLeft: true,
          image: Slide4,
          imageWidth: 1024,
          imageHeight: 344,
          newWindow: false,
          text:
            "Effizienz bei WIKA heißt vor allem Effizienz für die Kunden von WIKA. Hochwertige Produkte, die punktgenaue Leistung bringen: Weniger dürfen Sie von uns nicht erwarten!",
          title: "Effizienz liegt im Detail",
          url: "#"
        },
        {
          captionTop: true,
          captionLeft: false,
          image: Slide5,
          imageWidth: 1024,
          imageHeight: 344,
          newWindow: false,
          text:
            "Unsere Zuverlässigkeit basiert auf dem Bewusstsein der Verantwortung. Unsere Kunden können sich darauf verlassen, dass die WIKA-Geräte, die weltweit in ihren Anlagen eingebaut sind, jederzeit zuverlässig und exakt funktionieren.",
          title: "Zuverlässigkeit liegt im Detail",
          url: "#"
        }
      ],
      productLinks: [
        {
          id: "1",
          words: [
            ["Manometer", 10, "https://google.com", false],
            ["Drucksensoren", 10, "https://google.com", true],
            ["Druckschalter", 7, "https://google.com"],
            ["Digitalmanometer", 4, "https://google.com"],
            ["Prozesstransmitter", 4, "https://google.com"],
            ["Druckmittler", 4, "https://google.com"],
            ["Druckmittlersysteme", 4, "https://google.com"],
            ["Ventile und Schutzvorrichtungen", 4, "https://google.com"],
            ["Manometer mit Ausgangssignal", 3, "https://google.com"],
            ["Kontaktmanometer", 3, "https://google.com"],
            ["Engineered Solutions", 1, "https://google.com"],
            ["Montagezubehör", 1, "https://google.com"],
            ["Elektrisches Zubehör", 1, "https://google.com"]
          ],
          text:
            "WIKA bietet eine komplette Palette elektronischer, mechatronischer und mechanischer Druckmessgeräte für Messungen von Relativ-, Absolut- und Differenzdruck. Diese sind in den Messbereichen 0 ... 0,6 mbar bis 0 ... 15.000 bar verfügbar.",
          title: "Druck",
          url: "https://www.google.com"
        },
        {
          id: "2",
          words: [
            ["Zeigerthermometer", 10, "https://google.com"],
            ["Widerstandsthermometer", 10, "https://google.com"],
            ["Thermoelemente", 7, "https://google.com"],
            ["Schutzrohre", 7, "https://google.com"],
            ["Temperaturtransmitter", 4, "https://google.com"],
            ["Temperaturregler", 4, "https://google.com"],
            ["Digitalanzeigen", 3, "https://google.com"],
            ["Temperaturschalter", 3, "https://google.com"],
            ["Stufen-Thermometer", 3, "https://google.com"],
            ["Thermometer mit Schaltkontakten", 1, "https://google.com"],
            ["Engineered Solutions", 1, "https://google.com"],
            ["Kabel und Stecker", 1, "https://google.com"],
            ["Programmiereinheiten", 1, "https://google.com"],
            ["Rohroberflächen-Thermoelemente", 1, "https://google.com"]
          ],
          text:
            "Unser Programm umfasst elektrische, mechatronische und mechanische Temperaturmessgeräte. Dabei stehen ein umfangreiches Standard-Sortiment sowie spezielle Geräteausführungen für Ihre individuellen Anforderungen zur Verfügung.",
          title: "Temperatur",
          url: "#"
        },
        {
          id: "3",
          words: [
            ["Bypass-Niveaustandsanzeiger", 10, "https://google.com"],
            ["Bezugsgefäße", 6, "https://google.com"],
            ["Schauglasanzeiger", 3, "https://google.com"],
            ["Pegelsonden", 3, "https://google.com"],
            ["Kontinuierliche Messung mit Schwimmer", 3, "https://google.com"],
            ["Optoelektronische Schalter", 3, "https://google.com"],
            ["Engineered Solutions", 1, "https://google.com"],
            ["Zubehör für Bypass-Niveaustandsanzeiger", 1, "https://google.com"]
          ],
          text:
            "WIKA verfügt über ein umfangreiches Sortiment von Füllstandsmessgeräten für Temperaturen bis 450 °C, Dichten ab 400 kg/m<sup>3</sup> und Druckbereiche bis 500 bar. Kundenspezifische Sonderanfertigungen runden unser Angebot ab.",
          title: "Füllstand",
          url: "#"
        },
        {
          id: "4",
          words: [
            ["Kraftaufnehmer", 10, "https://google.com"],
            ["Wägezellen", 4, "https://google.com"],
            ["Hydraulische Kraftmesstechnik", 1, "https://google.com"],
            ["Engineered Solutions", 1, "https://google.com"]
          ],
          text:
            "Mit Kraftaufnehmern von WIKA setzen Sie auf Qualität, Erfahrung und Kompetenz – sowie auf individuelle Lösungen. Wir bieten Ihnen zudem die freie Auswahl aller wichtigen Technologien aus einer Hand: hydraulische Kraftmessung, Dehnungsmessstreifen sowie innovative Kraftmessung mit Dünnfilmtechnologie.",
          title: "Kraft",
          url: "#"
        },
        {
          id: "5",
          words: [
            ["Primäre Durchflusselemente", 10, "https://google.com"],
            ["Strömungsschalter", 3, "https://google.com"],
            ["Volumenstromsensoren", 1, "https://google.com"]
          ],
          text:
            "Unser Portfolio für primäre Durchflusselemente umfasst Steckblenden, Messstrecken, Durchflussdüsen, Venturirohre, Staudrucksonden und Drosselblenden. Mit unserem umfangreichen Produktprogramm sind wir in der Lage, nahezu alle industriellen Anwendungen abzudecken. Kundenspezifische Lösungen können nach Ihren speziellen Anforderungen entwickelt werden.",
          title: "Durchfluss",
          url: "#"
        },
        {
          id: "6",
          words: [
            ["Druckcontroller", 10, "https://google.com"],
            ["Kalibrierbäder", 8, "https://google.com"],
            ["Digitalmanometer", 6, "https://google.com"],
            ["Hand-Helds, Kalibratoren", 6, "https://google.com"],
            ["Kolbenmanometer", 6, "https://google.com"],
            ["Portable Druckerzeugung", 6, "https://google.com"],
            ["Präzisionsdruckmessgeräte", 3, "https://google.com"],
            ["Referenzthermometer", 3, "https://google.com"],
            ["Hand-Helds", 3, "https://google.com"],
            ["Widerstandsmessbrücken", 1, "https://google.com"],
            ["Elektrische Kalibriergeräte", 1, "https://google.com"],
            ["Engineered Solutions", 1, "https://google.com"],
            ["Zubehör", 1, "https://google.com"]
          ],
          text:
            "Höchste Präzision für jeden Anspruch. WIKA bietet ein breites Produktspektrum an Kalibriergeräten für die physikalischen Messgrößen Druck und Temperatur sowie für elektrische Messgrößen. Bei einem Großteil der Kalibriergeräte gewährleisten zahlreiche Patente einzigartige Leistungsmerkmale.",
          title: "Kalibrierung",
          url: "#"
        }
      ],
      events: [
        {
          image: "https://picsum.photos/200/200?random=1",
          category: "Messen",
          name: "Innoprom",
          date: "08.07.2019 - 11.07.2019",
          flag: FlagDeSmall,
          city: "Екатеринбург",
          location: "Halle: пав.3, Stand: 3S5",
          primaryLink: "#",
          secondaryLink: "#"
        },
        {
          image: "https://picsum.photos/200/200?random=2",
          category: "Messen",
          name: "FIEE Smart Energy",
          date: "23.07.2019 - 26.07.2019",
          flag: FlagDeSmall,
          city: "São Paulo/SP",
          location: "",
          primaryLink: "#",
          secondaryLink: "#"
        },
        {
          image: "https://picsum.photos/200/200?random=3",
          category: "Messen",
          name: "FIEE Smart Energy",
          date: "23.07.2019 - 26.07.2019",
          flag: FlagDeSmall,
          city: "São Paulo/SP",
          location: "",
          primaryLink: "#",
          secondaryLink: "#"
        }
      ],
      cookieDisclaimerConfig: {
        text:
          "Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.",
        link: {
          text: "Weitere Informationen",
          url: "#"
        },
        button: {
          text: "Zustimmen",
          colour: "blue"
        }
      }
    };
  }
};
</script>

<style module lang="scss">
@import "./StartPage.scss";
</style>
